const Whom = () => {
  return <section className="relative isolate w-full overflow-hidden bg-[#07130d] py-16 sm:py-20 lg:py-28">
            <img
    src="/images/Hiru/public_images/DSC09234-Enhanced-NR-Edit-copy.webp"
    alt="Von der Natur umgebener Ayurveda-Bereich zur Heilung und Entspannung"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
            <div className="absolute inset-0 bg-black/65" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/60 to-black/75" />

            <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center text-white">
                    <div className="mx-auto h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />
                    <p className="mt-6 font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-100">
                        Für wen ist Ayurveda geeignet?
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                        Für wen ist Ayurveda gedacht?
                    </h2>
                    <p className="mt-7 font-mulish text-base leading-8 text-white/90 sm:text-lg">
                        Die traditionelle Ayurveda-Behandlung betrachtet nicht nur einzelne Symptome, sondern heilt den Menschen als Ganzes und hilft dabei, viele Beschwerden an der Wurzel zu lösen.
                    </p>
                    <p className="mt-5 font-mulish text-base leading-8 text-white/90 sm:text-lg">
                        So geht Ayurveda besonders gezielt bei chronischen körperlichen Beschwerden vor, zum Beispiel bei den folgenden Beschwerden:
                    </p>
                </div>

                <div className="mx-auto mt-10 grid max-w-5xl gap-5 text-center md:grid-cols-2">
                    <div className="rounded-[22px] border border-white/20 bg-white/10 p-6 text-white backdrop-blur-md sm:p-8">
                        <h3 className="font-serif text-2xl font-semibold text-amber-100 sm:text-3xl">
                            Körperliche Beschwerden und chronische Symptome
                        </h3>
                        <p className="mt-4 font-mulish text-[15px] leading-8 text-white/88 sm:text-base">
                            Übelkeit, Verdauungsprobleme, Hauterkrankungen, Gewichtsprobleme, Kreislaufbeschwerden, Bluthochdruck, Asthma, Allergien, chronische Rückenschmerzen und Diabetes.
                        </p>
                    </div>
                    <div className="rounded-[22px] border border-white/20 bg-white/10 p-6 text-white backdrop-blur-md sm:p-8">
                        <h3 className="font-serif text-2xl font-semibold text-amber-100 sm:text-3xl">
                            Erschöpfung von Geist und Nerven
                        </h3>
                        <p className="mt-4 font-mulish text-[15px] leading-8 text-white/88 sm:text-base">
                            Täglicher Stress, starke Anspannung, Erschöpfung, Migräne, depressive Verstimmungen oder Schlafstörungen.
                        </p>
                    </div>
                </div>

                <div className="mx-auto mt-10 max-w-4xl text-center">
                    <p className="font-mulish text-base leading-8 text-white/90 sm:text-lg">
                        Die authentischen Behandlungsprogramme am Hiru Resort hören genau auf diese verschiedenen Signale von Körper und Geist und wirken sanft darauf hin, die ursprüngliche Gesundheit wiederherzustellen.
                    </p>
                    <p className="mt-6 font-serif text-xl leading-relaxed text-amber-100 sm:text-2xl">
                        In Verbindung mit dem natürlichen Rhythmus kehren Sie langsam zu Ihrer ursprünglichen, gesunden Balance zurück.
                    </p>
                    <p className="mt-5 font-mulish text-base leading-8 text-white/90 sm:text-lg">
                        Ayurveda ist die sanfte, aber kraftvolle Weisheit der Vorfahren, die Körper und Geist wieder in Einklang bringt.
                    </p>
                </div>
            </div>
        </section>;
};
export default Whom;
